{
  "payment.paymentMethod": {
    "APEXX_PAYMENT_CARD": "Credit or debit card"
  },
  "oneUpgrade": {
    "errors": {
      "tooFarToDepartureAndPointPaymentNotAllowed": {
        "heading": "Paid upgrades not yet available",
        "paragraph": "Travel class upgrades can be bought earliest <b>30 days before departure</b>."
      }
    }
  }
}
